import { render } from "./StatisticsByReferrers.vue?vue&type=template&id=49951f8e&ts=true&lang=pug"
import script from "./StatisticsByReferrers.vue?vue&type=script&lang=ts"
export * from "./StatisticsByReferrers.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__